import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { useBrand } from "../context/BrandContext";
import { IMAGES } from "../data/content";

export const CtaBand = () => {
  const b = useBrand();
  return (
    <section className="relative overflow-hidden bg-amber-500 text-slate-900" data-testid="cta-band">
      <img src={IMAGES.freight} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-15 mix-blend-multiply hidden md:block" />
      <div className="relative container-x py-16 md:py-20 grid gap-8 md:grid-cols-12 items-center">
        <div className="md:col-span-7">
          <div className="font-mono text-xs uppercase tracking-[0.25em]">Ready when you are</div>
          <h2 className="mt-3 font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">Get your vehicle moving.</h2>
          <p className="mt-4 text-base md:text-lg max-w-xl text-[#0B1017]/80">Instant estimate in seconds. No upfront payment. Official invoice after our team reviews your shipment.</p>
        </div>
        <div className="md:col-span-5 flex flex-col sm:flex-row md:flex-col lg:flex-row gap-3 md:justify-end">
          <Link to={{ pathname: "/", hash: "#quote" }} className="inline-flex items-center justify-center gap-2 h-14 px-7 bg-white text-slate-900 font-display font-bold uppercase tracking-wider shadow-md hover:bg-slate-50 transition-colors" data-testid="cta-band-quote-button">
            Get a Quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a href={`tel:${b.phone_tel}`} className="inline-flex items-center justify-center gap-2 h-14 px-7 border-2 border-slate-900 text-slate-900 font-display font-bold uppercase tracking-wider hover:bg-white/40 transition-colors" data-testid="cta-band-call-button">
            <Phone className="w-4 h-4" /> {b.phone_display}
          </a>
        </div>
      </div>
    </section>
  );
};
